export const buildSystemDesignFromLayout = (design, inverterName) => {
    if (!design) return null;

    const order =
      (Array.isArray(design?.inverterOrder) && design.inverterOrder.length
        ? design.inverterOrder
        : null) ||
      (Array.isArray(design?.layout)
        ? design.layout.map((_, idx) => `INVERTER #${idx + 1}`)
        : design?.layoutByInverter
        ? Object.keys(design.layoutByInverter)
        : []);

    const layoutByInverter =
      design?.layoutByInverter ||
      (Array.isArray(design?.layout)
        ? order.reduce((acc, name, idx) => {
            acc[name] = design.layout[idx] || [];
            return acc;
          }, {})
        : null);

    if (!order || !order.length || !layoutByInverter) return null;

    const layoutArray = Array.isArray(design?.layout)
      ? design.layout
      : order.map((label) => layoutByInverter[label] || []);

    const baseInvName = inverterName || design?.inverter || "INVERTER";
    const systemDesign = {};

    layoutArray.forEach((mppts, invIdx) => {
      const key = `${baseInvName}__${invIdx + 1}`;
      systemDesign[key] = mppts.map((mppt, mpptIdx) => {
        const mps = mppt?.modulesPerString;
        const inputs = Array.isArray(mppt?.inputs)
          ? mppt.inputs
              .map((inp, inputIdx) =>
                inp?.used
                  ? {
                      index: inputIdx + 1,
                      modules_per_string:
                        Number.isFinite(Number(mps)) && mps !== ""
                          ? Number(mps)
                          : mps ?? "",
                    }
                  : null
              )
              .filter(Boolean)
          : [];
        return {
          index: mpptIdx + 1,
          inputs,
          // Only a further plane is named; an untagged MPPT is on the primary,
          // which keeps a single-plane design exactly as it always was.
          ...(mppt?.orientation ? { orientation: mppt.orientation } : {}),
        };
      });
    });

    return systemDesign;
  };

export function layoutPreviewConfig(cfg, draft, inverterName) {
  const systemDesign = buildSystemDesignFromLayout(draft, inverterName);
  return systemDesign ? { ...cfg, systemDesign } : cfg;
}
